// docTemplates.js — vzory s poľami + nápovedami + podpismi vedľa seba (Mirko 2026-07-23).
export const DOC_VZORY = [
 {
  "key": "vyzva",
  "label": "Výzva na úhradu",
  "docType": "Výzva",
  "mode": "vec",
  "subject": "Výzva na úhradu faktúry č. [____]",
  "pozdrav": "S pozdravom",
  "body": "Dovoľujeme si Vás upozorniť, že v našej evidencii máme neuhradenú faktúru:\n\nčíslo faktúry: [____]\nsuma: [____] €\ndátum splatnosti: [____]\n\nZdvorilo Vás vyzývame na úhradu uvedenej sumy v lehote do [____] dní od doručenia tejto výzvy na účet [IBAN].\n\nV prípade, že platba bola medzitým uhradená, považujte túto výzvu za bezpredmetnú."
 },
 {
  "key": "oznamenie",
  "label": "Oznámenie",
  "docType": "Oznámenie",
  "mode": "vec",
  "subject": "Oznámenie",
  "pozdrav": "S pozdravom",
  "body": "Týmto si Vás dovoľujeme informovať, že [____]."
 },
 {
  "key": "potvrdenie",
  "label": "Potvrdenie o prevzatí",
  "docType": "Potvrdenie",
  "mode": "title",
  "subject": "POTVRDENIE O PREVZATÍ",
  "pozdrav": "",
  "body": "<p>Týmto potvrdzujem, že dňa [dátum prevzatia] som prevzal/a:<br>[predmet prevzatia]</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[odovzdal]<br>Odovzdal</td><td>______________________________<br>[prevzal]<br>Prevzal</td></tr></tbody></table>",
  "fields": [
   {
    "label": "Dátum prevzatia",
    "ph": "[dátum prevzatia]",
    "typ": "date"
   },
   {
    "label": "Predmet prevzatia",
    "ph": "[predmet prevzatia]",
    "typ": "textarea"
   },
   {
    "label": "Odovzdal (meno)",
    "ph": "[odovzdal]",
    "typ": "text"
   },
   {
    "label": "Prevzal (meno)",
    "ph": "[prevzal]",
    "typ": "text"
   }
  ]
 },
 {
  "key": "vratenie_faktury",
  "label": "Vrátenie faktúry",
  "docType": "List",
  "mode": "vec",
  "subject": "Vrátenie faktúry č. [číslo faktúry]",
  "pozdrav": "S pozdravom",
  "body": "Dobrý deň,\n\nvraciame Vám faktúru č. [číslo faktúry] zo dňa [dátum vystavenia] na sumu [suma faktúry], doručenú dňa [dátum doručenia].\n\nDôvod vrátenia: [dôvod vrátenia].\n\n[žiadosť]",
  "fields": [
   {
    "label": "Faktúra (došlé faktúry tohto partnera)",
    "ph": "[číslo faktúry]",
    "typ": "dosla_fa",
    "hint": "vyber faktúru — číslo, dátum vystavenia, doručenia a suma sa doplnia samy"
   },
   {
    "label": "Dátum vystavenia faktúry",
    "ph": "[dátum vystavenia]",
    "typ": "date"
   },
   {
    "label": "Suma faktúry",
    "ph": "[suma faktúry]",
    "typ": "text",
    "hint": "napr. 4 820,00 €"
   },
   {
    "label": "Doručená dňa",
    "ph": "[dátum doručenia]",
    "typ": "date"
   },
   {
    "label": "Dôvod vrátenia",
    "ph": "[dôvod vrátenia]",
    "typ": "select",
    "opts": [
     "nesprávne fakturačné údaje odberateľa",
     "suma nezodpovedá objednávke alebo súpisu prác",
     "chýba číslo objednávky alebo zákazky",
     "chýba príloha (súpis prác, dodací list)",
     "faktúra nepatrí našej firme",
     "faktúra je vystavená duplicitne"
    ],
    "hint": "do listu ide len vybraná možnosť"
   },
   {
    "label": "Čo žiadame",
    "ph": "[žiadosť]",
    "typ": "select",
    "default": "Prosíme o opravu a zaslanie opravenej faktúry.",
    "opts": [
     "Prosíme o opravu a zaslanie opravenej faktúry.",
     "Prosíme o stornovanie faktúry dobropisom.",
     "Faktúru prosíme vystaviť správnemu odberateľovi, našej firme nepatrí."
    ],
    "hint": "pri inom dôvode napíš vlastný text"
   }
  ]
 },
 {
  "key": "spl_vozidlo",
  "label": "Splnomocnenie — vozidlo",
  "docType": "Splnomocnenie",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<p class=\"doctitle\">SPLNOMOCNENIE</p><p class=\"docsub\">na používanie, vedenie a prevzatie motorového vozidla</p><p class=\"pre\"><b>Splnomocniteľ (vlastník / držiteľ vozidla):</b><br>obchodné meno:  KAMIR s.r.o.<br>sídlo:          Tovarné 29, 094 01 Tovarné<br>IČO:            48 029 882<br>DIČ:            2120047358<br>IČ DPH:         SK2120047358<br>zapísaná v Obchodnom registri Okresného súdu Prešov<br>zastúpená konateľom:  [meno a priezvisko konateľa], konateľ<br>(ďalej len „splnomocniteľ\")</p><p>týmto podľa § 31 a nasl. zákona č. 40/1964 Zb. Občiansky zákonník v znení neskorších predpisov splnomocňuje</p><p class=\"pre\"><b>Splnomocnenca (zamestnanca):</b><br>meno a priezvisko:   [meno a priezvisko zamestnanca]<br>dátum narodenia:     [dátum narodenia]<br>trvalý pobyt:        [adresa trvalého pobytu]<br>č. OP / VP / povolenia na pobyt:  [číslo dokladu]<br>(ďalej len „splnomocnenec\")</p><p>na používanie, vedenie a prevzatie motorového vozidla splnomocniteľa:<br>továrenská značka a typ:   [značka a model]<br>EČV:                       [evidenčné číslo vozidla]<br>VIN:                       [VIN]</p><p>Rozsah splnomocnenia:<br>Splnomocnenec je oprávnený uvedené motorové vozidlo viesť a používať na pracovné účely, prevziať ho a odovzdať (napr. zo servisu, z požičovne, od zmluvného partnera), predložiť vozidlo a doklady od neho pri cestnej kontrole orgánom Policajného zboru SR, ako aj vykonať bežné úkony spojené s jeho prevádzkou. Splnomocnenec NIE JE oprávnený vozidlo scudziť, zaťažiť ani inak s ním právne nakladať.</p><p>Platnosť splnomocnenia:  [do DD.MM.RRRR / na dobu trvania pracovného pomeru / do odvolania]</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[meno a priezvisko konateľa]<br>KAMIR s.r.o. · konateľ<br>Splnomocniteľ</td><td>______________________________<br>[meno a priezvisko zamestnanca]<br>Splnomocnenec<br>Splnomocnenie prijímam v celom rozsahu.</td></tr></tbody></table>",
  "fields": [
   {
    "label": "Meno a priezvisko zamestnanca",
    "ph": "[meno a priezvisko zamestnanca]",
    "zdroj": "zamestnanec.name",
    "typ": "text"
   },
   {
    "label": "Dátum narodenia",
    "ph": "[dátum narodenia]",
    "zdroj": "zamestnanec.birth_date",
    "typ": "date"
   },
   {
    "label": "Adresa trvalého pobytu",
    "ph": "[adresa trvalého pobytu]",
    "zdroj": "zamestnanec.adresa",
    "typ": "text"
   },
   {
    "label": "Číslo OP / vodičského preukazu / povolenia na pobyt",
    "ph": "[číslo dokladu]",
    "zdroj": "zamestnanec.doklad_cislo",
    "typ": "text",
    "hint": "číslo OP / vodičského preukazu / povolenia na pobyt (cudzinci)"
   },
   {
    "label": "Vozidlo — značka a model",
    "ph": "[značka a model]",
    "zdroj": "vozidlo.znacka_model",
    "typ": "text"
   },
   {
    "label": "EČV",
    "ph": "[evidenčné číslo vozidla]",
    "zdroj": "vozidlo.plate",
    "typ": "text"
   },
   {
    "label": "VIN",
    "ph": "[VIN]",
    "zdroj": "vozidlo.vin",
    "typ": "text"
   },
   {
    "label": "Platnosť splnomocnenia",
    "ph": "[do DD.MM.RRRR / na dobu trvania pracovného pomeru / do odvolania]",
    "typ": "text",
    "default": "do odvolania",
    "hint": "napr. do 31.12.2026 / do vykonania úkonu / do odvolania"
   }
  ]
 },
 {
  "key": "spl_di",
  "label": "Splnomocnenie — dopravný inšpektorát",
  "docType": "Splnomocnenie",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<p class=\"doctitle\">SPLNOMOCNENIE</p><p class=\"docsub\">na zastupovanie vo veciach evidencie vozidiel</p><p class=\"pre\"><b>Splnomocniteľ:</b><br>obchodné meno:  KAMIR s.r.o.<br>sídlo:          Tovarné 29, 094 01 Tovarné<br>IČO:            48 029 882<br>DIČ:            2120047358<br>IČ DPH:         SK2120047358<br>zapísaná v Obchodnom registri Okresného súdu Prešov<br>zastúpená konateľom:  [meno a priezvisko konateľa], konateľ<br>(ďalej len „splnomocniteľ\")</p><p>týmto podľa § 31 a nasl. zákona č. 40/1964 Zb. Občiansky zákonník v znení neskorších predpisov a v súlade so zákonom č. 8/2009 Z. z. o cestnej premávke v znení neskorších predpisov splnomocňuje</p><p class=\"pre\"><b>Splnomocnenca:</b><br>meno a priezvisko:   [meno a priezvisko splnomocnenca]<br>dátum narodenia:     [dátum narodenia]<br>trvalý pobyt:        [adresa trvalého pobytu]<br>č. OP / povolenia na pobyt:  [číslo OP]<br>(ďalej len „splnomocnenec\")</p><p>aby splnomocniteľa v plnom rozsahu zastupoval pred orgánmi Policajného zboru SR — Okresným dopravným inšpektorátom [mesto], prípadne pred ktorýmkoľvek dopravným inšpektorátom v Slovenskej republike, vo veciach evidencie motorového vozidla:<br>továrenská značka a typ:   [značka a model]<br>EČV:                       [evidenčné číslo vozidla]<br>VIN:                       [VIN]</p><p>Rozsah splnomocnenia:<br>Splnomocnenec je oprávnený najmä:<br>- prihlásiť vozidlo do evidencie a odhlásiť vozidlo z evidencie,<br>- vykonať prepis vozidla — zápis zmeny držiteľa a/alebo vlastníka vozidla,<br>- nahlásiť a zapísať zmeny údajov v osvedčení o evidencii časť I a II (technickom preukaze),<br>- požiadať o vydanie/výmenu osvedčenia o evidencii, tabuliek s evidenčným číslom a o dočasné/trvalé vyradenie vozidla z evidencie,<br>- preberať a podpisovať súvisiace podania, potvrdenia a rozhodnutia, nahliadať do spisu, uhrádzať správne poplatky a preberať doklady a tabuľky s EČV.</p><p>Splnomocnenec je oprávnený úkony podľa tohto splnomocnenia vykonať aj prostredníctvom elektronickej služby, ak to príslušný orgán umožňuje.</p><p>Platnosť splnomocnenia:  [do DD.MM.RRRR / do vykonania úkonu / do odvolania]</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[meno a priezvisko konateľa]<br>KAMIR s.r.o. · konateľ<br>Splnomocniteľ</td><td>______________________________<br>[meno a priezvisko splnomocnenca]<br>Splnomocnenec<br>Splnomocnenie prijímam v celom rozsahu.</td></tr></tbody></table>",
  "fields": [
   {
    "label": "Meno a priezvisko splnomocnenca",
    "ph": "[meno a priezvisko splnomocnenca]",
    "typ": "text"
   },
   {
    "label": "Dátum narodenia",
    "ph": "[dátum narodenia]",
    "zdroj": "zamestnanec.birth_date",
    "typ": "date"
   },
   {
    "label": "Adresa trvalého pobytu",
    "ph": "[adresa trvalého pobytu]",
    "zdroj": "zamestnanec.adresa",
    "typ": "text"
   },
   {
    "label": "Číslo OP / povolenia na pobyt",
    "ph": "[číslo OP]",
    "typ": "text",
    "hint": "číslo občianskeho preukazu"
   },
   {
    "label": "Mesto dopravného inšpektorátu",
    "ph": "[mesto]",
    "typ": "text",
    "hint": "mesto príslušného úradu"
   },
   {
    "label": "Vozidlo — značka a model",
    "ph": "[značka a model]",
    "zdroj": "vozidlo.znacka_model",
    "typ": "text"
   },
   {
    "label": "EČV",
    "ph": "[evidenčné číslo vozidla]",
    "zdroj": "vozidlo.plate",
    "typ": "text"
   },
   {
    "label": "VIN",
    "ph": "[VIN]",
    "zdroj": "vozidlo.vin",
    "typ": "text"
   },
   {
    "label": "Platnosť splnomocnenia",
    "ph": "[do DD.MM.RRRR / do vykonania úkonu / do odvolania]",
    "typ": "text",
    "default": "do odvolania",
    "hint": "napr. do 31.12.2026 / do vykonania úkonu / do odvolania"
   }
  ]
 },
 {
  "key": "spl_cudzinci",
  "label": "Splnomocnenie — cudzinecká polícia",
  "docType": "Splnomocnenie",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<p class=\"doctitle\">SPLNOMOCNENIE</p><p class=\"docsub\">na zastupovanie vo veciach pobytu a zamestnávania cudzincov</p><p class=\"pre\"><b>Splnomocniteľ (zamestnávateľ):</b><br>obchodné meno:  KAMIR s.r.o.<br>sídlo:          Tovarné 29, 094 01 Tovarné<br>IČO:            48 029 882<br>DIČ:            2120047358<br>IČ DPH:         SK2120047358<br>zapísaná v Obchodnom registri Okresného súdu Prešov<br>zastúpená konateľom:  [meno a priezvisko konateľa], konateľ<br>(ďalej len „splnomocniteľ\")</p><p>týmto podľa § 31 a nasl. zákona č. 40/1964 Zb. Občiansky zákonník v znení neskorších predpisov, v spojení so zákonom č. 404/2011 Z. z. o pobyte cudzincov, zákonom č. 5/2004 Z. z. o službách zamestnanosti a zákonom č. 71/1967 Zb. o správnom konaní (správny poriadok) v znení neskorších predpisov splnomocňuje</p><p class=\"pre\"><b>Splnomocnenca:</b><br>meno a priezvisko:   [meno a priezvisko splnomocnenca]<br>dátum narodenia:     [dátum narodenia]<br>trvalý pobyt:        [adresa trvalého pobytu]<br>č. OP / povolenia na pobyt:  [číslo OP]<br>(ak je splnomocnencom právnická osoba / advokát, uveďte obchodné meno, sídlo, IČO a osobu konajúcu v jej mene)<br>(ďalej len „splnomocnenec\")</p><p>aby splnomocniteľa zastupoval pred Oddelením cudzineckej polície Policajného zboru [mesto], prípadne pred ktorýmkoľvek útvarom Úradu hraničnej a cudzineckej polície PZ, ako aj pred Úradom práce, sociálnych vecí a rodiny a ďalšími príslušnými orgánmi, vo veciach pobytu a zamestnávania cudzincov — štátnych príslušníkov tretích krajín, a to v konaní týkajúcom sa:<br>zamestnanca / cudzinca:  [meno a priezvisko cudzinca, štátna príslušnosť, dátum narodenia]  (alebo: všetkých zamestnávaných cudzincov splnomocniteľa)</p><p>Rozsah splnomocnenia:<br>Splnomocnenec je oprávnený najmä:<br>- podávať žiadosti a nahlásenia súvisiace s prechodným pobytom na účel zamestnania, jeho obnovením a so zamestnávaním cudzincov (vrátane potvrdenia o možnosti obsadenia voľného pracovného miesta a informačných kariet),<br>- predkladať a preberať doklady, prílohy a rozhodnutia, dopĺňať podania, nahliadať do spisu a robiť si z neho výpisy,<br>- prijímať doručované písomnosti, robiť vyhlásenia, uhrádzať správne poplatky a preberať doklad o pobyte,<br>- zastupovať splnomocniteľa pri ústnom pojednávaní a v ďalších úkonoch správneho konania v uvedených veciach.</p><p>Toto splnomocnenie sa vzťahuje na úkony voči vyššie uvedeným orgánom v Slovenskej republike.</p><p>Platnosť splnomocnenia:  [do DD.MM.RRRR / do právoplatného skončenia konania / do odvolania]</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[meno a priezvisko konateľa]<br>KAMIR s.r.o. · konateľ<br>Splnomocniteľ</td><td>______________________________<br>[meno a priezvisko splnomocnenca]<br>Splnomocnenec<br>Splnomocnenie prijímam v celom rozsahu.</td></tr></tbody></table>",
  "fields": [
   {
    "label": "Meno a priezvisko splnomocnenca",
    "ph": "[meno a priezvisko splnomocnenca]",
    "typ": "text"
   },
   {
    "label": "Dátum narodenia",
    "ph": "[dátum narodenia]",
    "zdroj": "zamestnanec.birth_date",
    "typ": "date"
   },
   {
    "label": "Adresa trvalého pobytu",
    "ph": "[adresa trvalého pobytu]",
    "zdroj": "zamestnanec.adresa",
    "typ": "text"
   },
   {
    "label": "Číslo OP / povolenia na pobyt",
    "ph": "[číslo OP]",
    "typ": "text",
    "hint": "číslo občianskeho preukazu"
   },
   {
    "label": "Mesto oddelenia cudzineckej polície",
    "ph": "[mesto]",
    "typ": "text",
    "hint": "mesto príslušného úradu"
   },
   {
    "label": "Cudzinec (meno, štátna prísl., dát. nar.)",
    "ph": "[meno a priezvisko cudzinca, štátna príslušnosť, dátum narodenia]",
    "typ": "textarea"
   },
   {
    "label": "Platnosť splnomocnenia",
    "ph": "[do DD.MM.RRRR / do právoplatného skončenia konania / do odvolania]",
    "typ": "text",
    "default": "do odvolania",
    "hint": "napr. do 31.12.2026 / do vykonania úkonu / do odvolania"
   }
  ]
 },
 {
  "key": "spl_vseobecne",
  "label": "Splnomocnenie — všeobecné",
  "docType": "Splnomocnenie",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<p class=\"doctitle\">VŠEOBECNÉ SPLNOMOCNENIE</p><p class=\"pre\"><b>Splnomocniteľ:</b><br>obchodné meno:  KAMIR s.r.o.<br>sídlo:          Tovarné 29, 094 01 Tovarné<br>IČO:            48 029 882<br>DIČ:            2120047358<br>IČ DPH:         SK2120047358<br>zapísaná v Obchodnom registri Okresného súdu Prešov<br>zastúpená konateľom:  [meno a priezvisko konateľa], konateľ<br>(ďalej len „splnomocniteľ\")</p><p>týmto podľa § 31 a nasl. zákona č. 40/1964 Zb. Občiansky zákonník v znení neskorších predpisov splnomocňuje</p><p class=\"pre\"><b>Splnomocnenca:</b><br>meno a priezvisko:   [meno a priezvisko splnomocnenca]<br>dátum narodenia:     [dátum narodenia]<br>trvalý pobyt:        [adresa trvalého pobytu]<br>č. OP / povolenia na pobyt:  [číslo OP]<br>(ďalej len „splnomocnenec\")</p><p>aby splnomocniteľa zastupoval pri úradných a administratívnych úkonoch voči orgánom verejnej správy, štátnej správy a samosprávy, súdom a iným inštitúciám v Slovenskej republike, a to v tomto rozsahu:<br>[vymedzte konkrétne úrady a/alebo druhy úkonov — napr. daňový úrad, Sociálna poisťovňa, zdravotné poisťovne, živnostenský úrad, kataster, pošta, banka — čím konkrétnejšie, tým lepšie]</p><p>Rozsah splnomocnenia:<br>Splnomocnenec je oprávnený najmä podávať a preberať písomnosti, žiadosti, oznámenia a podania, nahliadať do spisov a robiť z nich výpisy, prijímať doručované zásielky a úradnú poštu, vyžadovať a preberať potvrdenia, výpisy a rozhodnutia, uhrádzať správne a súdne poplatky a robiť vyhlásenia potrebné na vybavenie uvedených úkonov.</p><p>Toto splnomocnenie sa vzťahuje výlučne na úkony vymedzené vyššie a NEoprávňuje splnomocnenca na obchodné vedenie spoločnosti ani na konanie v mene spoločnosti nad rámec tohto splnomocnenia.</p><p>Platnosť splnomocnenia:  [do DD.MM.RRRR / do odvolania]</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[meno a priezvisko konateľa]<br>KAMIR s.r.o. · konateľ<br>Splnomocniteľ</td><td>______________________________<br>[meno a priezvisko splnomocnenca]<br>Splnomocnenec<br>Splnomocnenie prijímam v celom rozsahu.</td></tr></tbody></table>",
  "fields": [
   {
    "label": "Meno a priezvisko splnomocnenca",
    "ph": "[meno a priezvisko splnomocnenca]",
    "typ": "text"
   },
   {
    "label": "Dátum narodenia",
    "ph": "[dátum narodenia]",
    "zdroj": "zamestnanec.birth_date",
    "typ": "date"
   },
   {
    "label": "Adresa trvalého pobytu",
    "ph": "[adresa trvalého pobytu]",
    "zdroj": "zamestnanec.adresa",
    "typ": "text"
   },
   {
    "label": "Číslo OP / povolenia na pobyt",
    "ph": "[číslo OP]",
    "typ": "text",
    "hint": "číslo občianskeho preukazu"
   },
   {
    "label": "Úrady a úkony (konkrétne)",
    "ph": "[vymedzte konkrétne úrady a/alebo druhy úkonov — napr. daňový úrad, Sociálna poisťovňa, zdravotné poisťovne, živnostenský úrad, kataster, pošta, banka — čím konkrétnejšie, tým lepšie]",
    "typ": "textarea"
   },
   {
    "label": "Platnosť splnomocnenia",
    "ph": "[do DD.MM.RRRR / do odvolania]",
    "typ": "text",
    "default": "do odvolania",
    "hint": "napr. do 31.12.2026 / do vykonania úkonu / do odvolania"
   }
  ]
 },
 {
  "key": "vozidlo_protokol",
  "label": "Protokol — odovzdanie/prevzatie vozidla",
  "docType": "Protokol",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<p>ODOVZDÁVACÍ A PREBERACÍ PROTOKOL MOTOROVÉHO VOZIDLA</p><p>(protokol o odovzdaní a prevzatí služobného motorového vozidla)</p><p>Odovzdávajúci (zamestnávateľ):<br>KAMIR s.r.o.<br>Sídlo: Tovarné 29, 094 01 Tovarné<br>IČO: 48029882<br>DIČ: 2120047358<br>IČ DPH: SK2120047358<br>Zapísaná v Obchodnom registri Okresného súdu Prešov, oddiel Sro, vložka č. 31144/P<br>Zastúpená konateľom: [meno a priezvisko konateľa]<br>(ďalej len „zamestnávateľ\")</p><p>Preberajúci (zamestnanec):<br>Meno a priezvisko: [meno a priezvisko zamestnanca]<br>Dátum narodenia: [dátum narodenia zamestnanca]<br>Osobné číslo: [osobné číslo zamestnanca]<br>Číslo vodičského preukazu: [číslo vodičského preukazu]<br>(ďalej len „zamestnanec\")</p><p>Identifikácia vozidla:<br>Značka a model: [značka a model vozidla]<br>Evidenčné číslo vozidla (EČV): [EČV]<br>Identifikačné číslo vozidla (VIN): [VIN]</p><p>Tento protokol sa vyhotovuje v súvislosti so zverením služobného motorového vozidla zamestnancovi na plnenie pracovných úloh. Zaznamenaním skutočného stavu vozidla pri jeho odovzdaní a vrátení tvorí písomný doklad podľa § 185 Zákonníka práce a súčasne písomné potvrdenie o prevzatí zvereného predmetu podľa § 182 Zákonníka práce.</p><p>ČASŤ A – ODOVZDANIE VOZIDLA ZAMESTNANCOVI</p><p>Stav pri odovzdaní:<br>Stav tachometra: [stav tachometra pri odovzdaní] km<br>Stav paliva: [stav paliva pri odovzdaní]<br>Počet odovzdaných kľúčov: [počet kľúčov] ks</p><p>Stav vozidla a viditeľné poškodenia pri odovzdaní:<br>[popis stavu vozidla pri odovzdaní]</p><p>Odovzdané príslušenstvo, doklady a povinné vybavenie (označte áno/nie):<br>[ ] Osvedčenie o evidencii vozidla (OEV) — časť I / časť II<br>[ ] Doklad o poistení zodpovednosti (zelená karta)<br>[ ] Diaľničná známka<br>[ ] Autolekárnička<br>[ ] Výstražný trojuholník<br>[ ] Reflexná bezpečnostná vesta<br>[ ] Náhradné koleso / sada na opravu defektu<br>[ ] Iné:</p><p>Povinnosti preberajúceho zamestnanca:<br>1. Zamestnanec preberá vozidlo do užívania na plnenie pracovných úloh a je povinný starať sa oň s náležitou starostlivosťou, chrániť ho pred poškodením, stratou, zničením a zneužitím a dodržiavať pokyny výrobcu a zamestnávateľa.<br>2. Zamestnanec je povinný riadiť vozidlo v súlade so všeobecne záväznými právnymi predpismi, najmä s predpismi o cestnej premávke, a používať vozidlo len na účely súvisiace s výkonom práce.<br>3. Zamestnanec je povinný zabezpečovať pravidelnú údržbu, kontrolu prevádzkových kvapalín a technický stav vozidla a bezodkladne hlásiť zamestnávateľovi každú poruchu, poškodenie, dopravnú nehodu, škodovú udalosť alebo odcudzenie vozidla či jeho vybavenia.<br>4. Súkromné použitie vozidla: [režim súkromného použitia]. (V prípade zákazu súkromného použitia sa vozidlo smie používať výlučne na služobné účely.)<br>5. Zamestnanec zodpovedá za škodu na zverenom vozidle podľa príslušných ustanovení Zákonníka práce.</p><p>Vyhlásenie zmluvných strán:<br>Zamestnanec svojím podpisom potvrdzuje, že vyššie uvedené vozidlo vrátane príslušenstva, dokladov a povinného vybavenia prevzal v uvedenom stave, s uvedeným stavom tachometra a paliva, a že bol oboznámený so svojimi povinnosťami a s pokynmi na jeho používanie. Zamestnávateľ potvrdzuje, že vozidlo v uvedenom stave zamestnancovi odovzdal.</p><p>V [miesto], dňa [dátum]</p><p>Za zamestnávateľa (odovzdávajúci)                     Zamestnanec (preberajúci)<br>[meno a priezvisko konateľa]                                   [meno a priezvisko zamestnanca]</p><p>ČASŤ B – VRÁTENIE VOZIDLA ZAMESTNÁVATEĽOVI</p><p>Dátum vrátenia vozidla: [dátum vrátenia]</p><p>Stav pri vrátení:<br>Stav tachometra: [stav tachometra pri vrátení] km<br>Stav paliva: [stav paliva pri vrátení]</p><p>Stav vozidla a viditeľné poškodenia pri vrátení:<br>[popis stavu vozidla pri vrátení]</p><p>Vrátené príslušenstvo, doklady a povinné vybavenie (označte áno/nie):<br>[ ] Osvedčenie o evidencii vozidla (OEV) — časť I / časť II<br>[ ] Doklad o poistení zodpovednosti (zelená karta)<br>[ ] Diaľničná známka<br>[ ] Autolekárnička<br>[ ] Výstražný trojuholník<br>[ ] Reflexná bezpečnostná vesta<br>[ ] Náhradné koleso / sada na opravu defektu<br>[ ] Kľúče od vozidla — počet vrátených kľúčov:  ks<br>[ ] Iné:</p><p>Vyhlásenie zmluvných strán:<br>Zamestnanec vyhlasuje, že vozidlo vrátane príslušenstva, dokladov a povinného vybavenia vracia v uvedenom stave. Zamestnávateľ svojím podpisom potvrdzuje prevzatie vráteného vozidla. Prípadné zistené poškodenia nad rámec bežného opotrebenia sú zaznamenané vyššie a budú riešené v súlade so Zákonníkom práce.</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[meno a priezvisko zamestnanca]<br>Zamestnanec (odovzdávajúci)</td><td>______________________________<br>[meno a priezvisko konateľa]<br>konateľ<br>Za zamestnávateľa (preberajúci)</td></tr></tbody></table>",
  "fields": [
   {
    "label": "Meno a priezvisko zamestnanca",
    "ph": "[meno a priezvisko zamestnanca]",
    "zdroj": "zamestnanec.name",
    "typ": "text"
   },
   {
    "label": "Dátum narodenia zamestnanca",
    "ph": "[dátum narodenia zamestnanca]",
    "typ": "date"
   },
   {
    "label": "Osobné číslo zamestnanca",
    "ph": "[osobné číslo zamestnanca]",
    "typ": "text",
    "hint": "ak firma vedie osobné čísla; inak prázdne",
    "nepovinne": true
   },
   {
    "label": "Číslo vodičského preukazu",
    "ph": "[číslo vodičského preukazu]",
    "typ": "text",
    "hint": "číslo vodičského preukazu zamestnanca"
   },
   {
    "label": "Značka a model vozidla",
    "ph": "[značka a model vozidla]",
    "typ": "text"
   },
   {
    "label": "Evidenčné číslo vozidla (EČV)",
    "ph": "[EČV]",
    "typ": "text"
   },
   {
    "label": "Identifikačné číslo vozidla (VIN)",
    "ph": "[VIN]",
    "zdroj": "vozidlo.vin",
    "typ": "text"
   },
   {
    "label": "Stav tachometra pri odovzdaní (km)",
    "ph": "[stav tachometra pri odovzdaní]",
    "typ": "number"
   },
   {
    "label": "Stav paliva pri odovzdaní",
    "ph": "[stav paliva pri odovzdaní]",
    "typ": "text",
    "hint": "napr. plná / 3/4 / 1/2 / 1/4"
   },
   {
    "label": "Počet odovzdaných kľúčov (ks)",
    "ph": "[počet kľúčov]",
    "typ": "number"
   },
   {
    "label": "Stav vozidla a viditeľné poškodenia pri odovzdaní",
    "ph": "[popis stavu vozidla pri odovzdaní]",
    "typ": "textarea",
    "hint": "napr. bez viditeľných poškodení / škrabanec ľavé predné dvere"
   },
   {
    "label": "Súkromné použitie vozidla (povolené / zakázané)",
    "ph": "[režim súkromného použitia]",
    "typ": "text",
    "default": "zakázané",
    "hint": "zakázané, alebo povolené (pri povolení = 1% daň zo vstupnej ceny mesačne)"
   },
   {
    "label": "Dátum vrátenia vozidla",
    "ph": "[dátum vrátenia]",
    "typ": "date"
   },
   {
    "label": "Stav tachometra pri vrátení (km)",
    "ph": "[stav tachometra pri vrátení]",
    "typ": "number"
   },
   {
    "label": "Stav paliva pri vrátení",
    "ph": "[stav paliva pri vrátení]",
    "typ": "text",
    "hint": "napr. plná / 3/4 / 1/2 / 1/4"
   },
   {
    "label": "Stav vozidla a viditeľné poškodenia pri vrátení",
    "ph": "[popis stavu vozidla pri vrátení]",
    "typ": "textarea",
    "hint": "napr. bez nových poškodení / nový oder na nárazníku"
   }
  ]
 },
 {
  "key": "hmotna_zodpovednost",
  "label": "Dohoda o hmotnej zodpovednosti",
  "docType": "Dohoda",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<p>DOHODA O HMOTNEJ ZODPOVEDNOSTI ZA ZVERENÉ HODNOTY</p><p>uzatvorená podľa § 182 a nasl. zákona č. 311/2001 Z. z. Zákonník práce v znení neskorších predpisov (ďalej len „Zákonník práce\")</p><p>I. ZMLUVNÉ STRANY</p><p>Zamestnávateľ:<br>KAMIR s.r.o.<br>Sídlo: Tovarné 29, 094 01 Tovarné<br>IČO: 48029882<br>DIČ: 2120047358<br>IČ DPH: SK2120047358<br>Zapísaná v Obchodnom registri Okresného súdu Prešov<br>Zastúpená konateľom: [meno a priezvisko konateľa]<br>(ďalej len „zamestnávateľ\")</p><p>a</p><p>Zamestnanec:<br>Meno a priezvisko: [meno a priezvisko zamestnanca]<br>Dátum narodenia: [dátum narodenia]<br>Trvalý pobyt: [adresa trvalého pobytu zamestnanca]<br>Osobné číslo: [osobné číslo]<br>Pracovná pozícia: [pracovná pozícia]<br>(ďalej len „zamestnanec\")</p><p>(zamestnávateľ a zamestnanec ďalej spoločne aj ako „zmluvné strany\")</p><p>II. PREDMET DOHODY</p><p>1. Zamestnanec touto dohodou preberá hmotnú zodpovednosť za hodnoty, ktoré mu boli alebo budú zamestnávateľom zverené na vyúčtovanie a s ktorými je zamestnanec v súvislosti s výkonom svojej práce oprávnený a povinný disponovať.</p><p>2. Zverenými hodnotami na účely tejto dohody sú najmä hotovosť, ceniny, tovar, zásoby materiálu a ďalšie hodnoty určené na obeh alebo obrat, ako aj zverené predmety, ktoré je zamestnanec povinný vyúčtovať, a to konkrétne: [predmet zverenia].</p><p>3. Zamestnanec vyhlasuje, že v deň podpisu tejto dohody dovŕšil vek 18 rokov, čím je splnená podmienka platnosti dohody podľa § 182 ods. 2 Zákonníka práce.</p><p>III. ROZSAH ZODPOVEDNOSTI</p><p>1. Zamestnanec zodpovedá za schodok vzniknutý na zverených hodnotách podľa čl. II tejto dohody. Za schodok sa považuje rozdiel medzi skutočným stavom zverených hodnôt a stavom, ktorý mal podľa účtovnej alebo inej evidencie existovať a ktorý zamestnanec nevie preukázateľne zdôvodniť.</p><p>2. Zamestnanec je povinný nahradiť zamestnávateľovi zistený schodok na zverených hodnotách v plnej výške.</p><p>3. Ak zverené hodnoty prevzalo na pracovisku viac zamestnancov, ktorí s ním uzatvorili dohodu o hmotnej zodpovednosti, môže byť dojednaná spoločná hmotná zodpovednosť; v takom prípade zodpovedajú zamestnanci za schodok spoločne podľa § 182 ods. 1 druhá veta Zákonníka práce a jednotlivé podiely náhrady sa určia v pomere podľa Zákonníka práce.</p><p>IV. POVINNOSTI ZAMESTNANCA</p><p>1. Zamestnanec je povinný počínať si tak, aby na zverených hodnotách nevznikol schodok, škoda ani ich strata, zničenie alebo poškodenie.</p><p>2. Zamestnanec je povinný najmä:<br>a) so zverenými hodnotami hospodáriť riadne, hospodárne a v súlade s pokynmi zamestnávateľa a všeobecne záväznými právnymi predpismi,<br>b) viesť riadnu a úplnú evidenciu zverených hodnôt a vyúčtovať ich spôsobom a v lehotách určených zamestnávateľom,<br>c) chrániť zverené hodnoty pred stratou, zničením, poškodením, zneužitím alebo odcudzením a zabezpečiť ich pred prístupom neoprávnených osôb,<br>d) bezodkladne písomne oznámiť zamestnávateľovi všetky nedostatky a prekážky, ktoré bránia riadnemu hospodáreniu so zverenými hodnotami, ako aj podozrenie zo straty, schodku alebo poškodenia,<br>e) umožniť zamestnávateľovi vykonanie inventarizácie a poskytnúť pri nej potrebnú súčinnosť.</p><p>3. Zamestnanec nesmie zverené hodnoty použiť na iný než dohodnutý účel, ani ich zveriť inej osobe bez písomného súhlasu zamestnávateľa.</p><p>V. INVENTARIZÁCIA</p><p>1. Inventarizácia zverených hodnôt sa vykoná pri uzatvorení tejto dohody, pri jej zániku, pri preradení zamestnanca na inú prácu alebo na iné pracovisko, pri jeho preložení a pri skončení pracovného pomeru, v súlade s § 184 Zákonníka práce.</p><p>2. Pri spoločnej hmotnej zodpovednosti sa inventarizácia vykoná pri uzatvorení dohôd so všetkými spoločne zodpovednými zamestnancami, pri zániku všetkých týchto dohôd, pri preradení alebo preložení všetkých spoločne zodpovedných zamestnancov, ako aj pri zmene vo funkcii vedúceho alebo jeho zástupcu a na žiadosť ktoréhokoľvek zo spoločne zodpovedných zamestnancov pri zmene v ich kolektíve.</p><p>3. O výsledku inventarizácie sa vyhotoví písomný záznam (inventarizačný zápis), ktorý podpíšu zamestnávateľ a zamestnanec. Skutočný stav zverených hodnôt zistený inventarizáciou pri uzatvorení tejto dohody sa považuje za východiskový stav, ktorý zamestnanec prevzal.</p><p>VI. ZBAVENIE ZODPOVEDNOSTI</p><p>1. Zamestnanec sa zbaví zodpovednosti celkom alebo sčasti, ak preukáže, že schodok vznikol celkom alebo sčasti bez jeho zavinenia, najmä ak mu bolo zanedbaním povinností zamestnávateľa znemožnené so zverenými hodnotami nakladať, disponovať alebo ich riadne opatrovať (§ 182 ods. 3 Zákonníka práce).</p><p>2. Dôkazné bremeno o tom, že schodok vznikol bez jeho zavinenia, znáša zamestnanec.</p><p>VII. TRVANIE A ODSTÚPENIE OD DOHODY</p><p>1. Táto dohoda nadobúda platnosť dňom jej podpisu oboma zmluvnými stranami a účinnosť dňom [deň vzniku hmotnej zodpovednosti], od ktorého zamestnanec zodpovedá za zverené hodnoty.</p><p>2. Zamestnanec môže od tejto dohody odstúpiť, ak je preradený na inú prácu, zaradený na iné pracovisko, ak je preložený, alebo ak zamestnávateľ v čase do jedného mesiaca od doručenia písomného upozornenia zamestnanca neodstráni nedostatky v pracovných podmienkach, ktoré bránia riadnemu hospodáreniu so zverenými hodnotami. Odstúpenie musí byť písomné (§ 183 Zákonníka práce).</p><p>3. Dohoda zaniká dňom skončenia pracovného pomeru, dňom odstúpenia od dohody alebo písomnou dohodou zmluvných strán. Zánikom dohody nie je dotknutá zodpovednosť zamestnanca za schodok zistený inventarizáciou vykonanou pri jej zániku.</p><p>VIII. ZÁVEREČNÉ USTANOVENIA</p><p>1. Právne vzťahy touto dohodou výslovne neupravené sa spravujú príslušnými ustanoveniami Zákonníka práce a ostatných všeobecne záväzných právnych predpisov Slovenskej republiky.</p><p>2. Táto dohoda je vyhotovená v dvoch rovnopisoch, po jednom pre každú zmluvnú stranu.</p><p>3. Zmeny a doplnky tejto dohody možno vykonať len písomnými, očíslovanými a oboma zmluvnými stranami podpísanými dodatkami.</p><p>4. Zmluvné strany vyhlasujú, že si dohodu prečítali, jej obsahu porozumeli, uzatvárajú ju slobodne, vážne, určite a zrozumiteľne, nie v tiesni ani za nápadne nevýhodných podmienok, na znak čoho ju vlastnoručne podpisujú.</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[meno a priezvisko konateľa]<br>konateľ<br>Zamestnávateľ — KAMIR s.r.o.</td><td>______________________________<br>[meno a priezvisko zamestnanca]<br>Zamestnanec</td></tr></tbody></table>",
  "fields": [
   {
    "label": "Meno a priezvisko zamestnanca",
    "ph": "[meno a priezvisko zamestnanca]",
    "zdroj": "zamestnanec.name",
    "typ": "text"
   },
   {
    "label": "Dátum narodenia",
    "ph": "[dátum narodenia]",
    "zdroj": "zamestnanec.birth_date",
    "typ": "date"
   },
   {
    "label": "Adresa trvalého pobytu zamestnanca",
    "ph": "[adresa trvalého pobytu zamestnanca]",
    "typ": "text"
   },
   {
    "label": "Osobné číslo",
    "ph": "[osobné číslo]",
    "typ": "text",
    "hint": "ak firma vedie osobné čísla; inak nechaj prázdne",
    "nepovinne": true
   },
   {
    "label": "Pracovná pozícia",
    "ph": "[pracovná pozícia]",
    "typ": "text"
   },
   {
    "label": "Predmet zverenia (hotovosť / ceniny / tovar / materiál / konkrétne predmety)",
    "ph": "[predmet zverenia]",
    "typ": "textarea",
    "hint": "napr. zverené náradie a stroje, materiál, hotovosť na prevádzkové výdavky"
   },
   {
    "label": "Deň vzniku hmotnej zodpovednosti (účinnosť)",
    "ph": "[deň vzniku hmotnej zodpovednosti]",
    "typ": "date"
   }
  ]
 },
 {
  "key": "naradie_protokol",
  "label": "Protokol — náradie a pomôcky",
  "docType": "Protokol",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<p>PREBERACÍ PROTOKOL NÁRADIA A PRACOVNÝCH POMÔCOK</p><p>uzatvorený podľa § 185 zákona č. 311/2001 Z. z. Zákonník práce v znení neskorších predpisov (ďalej len „Zákonník práce\")</p><p>Zamestnávateľ:<br>KAMIR s.r.o.<br>sídlo: Tovarné 29, 094 01 Tovarné<br>IČO: 48 029 882<br>DIČ: 2120047358<br>IČ DPH: SK2120047358<br>zapísaná v Obchodnom registri Okresného súdu Prešov<br>zastúpená konateľom: [meno a priezvisko konateľa]<br>(ďalej len „zamestnávateľ\")</p><p>Za zamestnávateľa odovzdáva (odovzdávajúci):<br>Meno a priezvisko: [odovzdávajúci meno]<br>Osobné číslo: [odovzdávajúci os. číslo]<br>Pracovná pozícia: [odovzdávajúci pozícia]</p><p>Zamestnanec (preberajúci):<br>Meno a priezvisko: [preberajúci meno]<br>Osobné číslo: [preberajúci os. číslo]<br>Pracovná pozícia: [preberajúci pozícia]<br>(ďalej len „zamestnanec\")</p><p>I. Predmet protokolu</p><p>1. Zamestnávateľ týmto zveruje zamestnancovi na výkon práce a užívanie nižšie uvedené náradie, stroje a pracovné pomôcky vo vlastníctve zamestnávateľa (ďalej len „zverené predmety\") a zamestnanec ich preberá do osobného užívania a zodpovednosti.</p><p>2. Zoznam zverených predmetov:</p><p>Por. č. | Názov / typ | Počet ks | Výrobné / inv. číslo | Hodnota (€) | Stav pri prevzatí<br>[zoznam náradia]</p><p>Celková hodnota zverených predmetov: [celková hodnota] €</p><p>3. Zamestnanec svojím podpisom potvrdzuje, že vyššie uvedené zverené predmety fyzicky prevzal v uvedenom počte a v uvedenom stave, že sú funkčné, kompletné a bez zjavných vád, ak nie je pri jednotlivej položke uvedené inak.</p><p>II. Práva a povinnosti zamestnanca</p><p>1. Zamestnanec je povinný používať zverené predmety výlučne na plnenie pracovných úloh a v súlade s ich určením, návodom na obsluhu, technickými, prevádzkovými a bezpečnostnými predpismi.</p><p>2. Zamestnanec je povinný o zverené predmety riadne sa starať, chrániť ich pred poškodením, stratou, zničením, zneužitím a odcudzením, zabezpečiť ich pred prístupom nepovolaných osôb a vykonávať ich bežnú údržbu.</p><p>3. Zamestnanec nesmie zverené predmety bez predchádzajúceho súhlasu zamestnávateľa požičiavať tretím osobám, prenechávať ich do užívania iným osobám, ani ich používať na súkromné účely.</p><p>4. Zamestnanec je povinný bezodkladne oznámiť zamestnávateľovi (odovzdávajúcemu alebo priamemu nadriadenému) akékoľvek poškodenie, stratu, odcudzenie alebo poruchu zverených predmetov, ako aj potrebu ich opravy. Pri odcudzení je zamestnanec povinný vec bez zbytočného odkladu oznámiť aj orgánom Policajného zboru.</p><p>5. Zamestnanec je povinný zverené predmety vrátiť zamestnávateľovi kedykoľvek na jeho výzvu, najneskôr pri skončení pracovného pomeru alebo pri zmene pracovného zaradenia, a to v stave zodpovedajúcom bežnému opotrebeniu.</p><p>III. Zodpovednosť za zverené predmety</p><p>1. Zamestnanec zodpovedá za stratu zverených predmetov podľa § 185 Zákonníka práce. Za zverené predmety zodpovedá zamestnanec v plnej výške.</p><p>2. Zamestnanec sa zbaví zodpovednosti celkom alebo sčasti, ak preukáže, že strata vznikla celkom alebo sčasti bez jeho zavinenia.</p><p>3. Za škodu spôsobenú na zverených predmetoch nad rámec bežného opotrebenia, ktorú zamestnanec spôsobil zavineným porušením povinností pri plnení pracovných úloh alebo v priamej súvislosti s ním, zodpovedá zamestnanec podľa § 179 Zákonníka práce.</p><p>4. Ak celková hodnota zverených predmetov presahuje 250 eur, zverujú sa zamestnancovi na základe osobitnej dohody o hmotnej zodpovednosti uzatvorenej podľa § 185 ods. 2 Zákonníka práce, ktorá tvorí neoddeliteľnú súčasť tejto agendy.</p><p>IV. Záverečné ustanovenia</p><p>1. Tento protokol je vyhotovený v dvoch rovnopisoch, po jednom pre každú zmluvnú stranu.</p><p>2. Zmluvné strany vyhlasujú, že protokol si prečítali, jeho obsahu porozumeli a na znak súhlasu ho vlastnoručne podpisujú.</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[odovzdávajúci meno]<br>Za zamestnávateľa (odovzdávajúci)</td><td>______________________________<br>[preberajúci meno]<br>Zamestnanec (preberajúci)</td></tr></tbody></table>",
  "fields": [
   {
    "label": "Meno a priezvisko odovzdávajúceho",
    "ph": "[odovzdávajúci meno]",
    "typ": "text",
    "hint": "kto vydáva náradie — skladník / vedúci / konateľ"
   },
   {
    "label": "Osobné číslo odovzdávajúceho",
    "ph": "[odovzdávajúci os. číslo]",
    "typ": "text",
    "nepovinne": true
   },
   {
    "label": "Pracovná pozícia odovzdávajúceho",
    "ph": "[odovzdávajúci pozícia]",
    "typ": "text"
   },
   {
    "label": "Meno a priezvisko preberajúceho (zamestnanca)",
    "ph": "[preberajúci meno]",
    "typ": "text"
   },
   {
    "label": "Osobné číslo preberajúceho",
    "ph": "[preberajúci os. číslo]",
    "typ": "text",
    "nepovinne": true
   },
   {
    "label": "Pracovná pozícia preberajúceho",
    "ph": "[preberajúci pozícia]",
    "typ": "text"
   },
   {
    "label": "Zoznam prevzatého náradia a pomôcok (jeden riadok = jedna položka: názov · ks · výrobné/inv. číslo · hodnota € · stav)",
    "ph": "[zoznam náradia]",
    "typ": "textarea",
    "hint": "jeden riadok = jedna položka: názov · ks · výrobné/inv. číslo · hodnota € · stav"
   },
   {
    "label": "Celková hodnota prevzatého majetku (€)",
    "ph": "[celková hodnota]",
    "typ": "number"
   }
  ]
 },
 {
  "key": "bozp",
  "label": "Oboznámenie BOZP a ochrana pred požiarmi",
  "docType": "Záznam",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<p>ZÁZNAM O OBOZNÁMENÍ ZAMESTNANCA<br>s bezpečnosťou a ochranou zdravia pri práci (BOZP) a ochranou pred požiarmi (OPP)</p><p>vyhotovený podľa § 7 zákona č. 124/2006 Z. z. o bezpečnosti a ochrane zdravia pri práci v znení neskorších predpisov a podľa § 4 zákona č. 314/2001 Z. z. o ochrane pred požiarmi v znení neskorších predpisov</p><p>ZAMESTNÁVATEĽ</p><p>KAMIR s.r.o.<br>Sídlo: Tovarné 29, 094 01 Tovarné<br>IČO: 48029882<br>DIČ: 2120047358<br>IČ DPH: SK2120047358<br>Zapísaná v Obchodnom registri Okresného súdu Prešov<br>Zastúpená konateľom: [meno a priezvisko konateľa]</p><p>Predmet činnosti: stavebná činnosť — strojové omietky a potery</p><p>ÚDAJE O OBOZNAMOVANOM ZAMESTNANCOVI</p><p>Meno a priezvisko: [meno a priezvisko zamestnanca]<br>Dátum narodenia: [dátum narodenia zamestnanca]<br>Pracovné zaradenie (pozícia): [pracovná pozícia]<br>Miesto výkonu práce: [miesto výkonu práce]<br>Dátum nástupu do zamestnania: [dátum nástupu]<br>Druh oboznámenia: [druh oboznámenia — vstupné / opakované / mimoriadne]</p><p>PREDMET A ROZSAH OBOZNÁMENIA</p><p>Zamestnanec bol oboznámený a poučený najmä o:</p><p>1. právnych predpisoch a ostatných predpisoch na zaistenie bezpečnosti a ochrany zdravia pri práci, ako aj o zásadách bezpečného správania sa na pracovisku a na stavbe;</p><p>2. pracovných a technologických postupoch pri strojovom omietaní a lití poterov, o bezpečnej obsluhe strojov, zariadení, náradia a pracovných pomôcok, ktoré má pri práci používať;</p><p>3. nebezpečenstvách a rizikách súvisiacich s vykonávanou prácou a s pracoviskom na stavbe (najmä pád z výšky a do hĺbky, pošmyknutie a zakopnutie, zásah elektrickým prúdom, práca s bremenami, prašnosť, hluk, chemické látky — cement, prísady a spojivá, pohyb mechanizmov a dopravných prostriedkov) a o ochranných opatreniach na ich obmedzenie;</p><p>4. správnom používaní, údržbe a skladovaní pridelených osobných ochranných pracovných prostriedkov (OOPP) — najmä ochrannej prilby, pracovnej a ochrannej obuvi, ochranných okuliarov, rukavíc, prostriedkov na ochranu dýchacích ciest a sluchu, prípadne prostriedkov na ochranu proti pádu;</p><p>5. zákaze požívať alkoholické nápoje, omamné a psychotropné látky pred a počas výkonu práce a o povinnosti podrobiť sa vyšetreniu na ich zistenie;</p><p>6. postupe a povinnostiach pri pracovnom úraze, nebezpečnej udalosti a bezprostrednom ohrození života alebo zdravia — o povinnosti bezodkladne oznámiť vznik úrazu nadriadenému, o poskytnutí prvej pomoci, o umiestnení lekárničky a o privolaní záchrannej služby (tiesňová linka 112 / 155);</p><p>7. predpisoch o ochrane pred požiarmi, o príčinách vzniku požiarov na pracovisku a na stavbe, o protipožiarnych a preventívnych opatreniach;</p><p>8. rozmiestnení a spôsobe použitia hasiacich prístrojov a ďalších vecných prostriedkov ochrany pred požiarmi, o umiestnení hlavných vypínačov a uzáverov;</p><p>9. povinnostiach zamestnanca pri vzniku požiaru — vyhlásení požiarneho poplachu, ohlásení požiaru (tiesňová linka 150 / 112), postupe podľa požiarnych poplachových smerníc a evakuácii osôb.</p><p>VYHLÁSENIE ZAMESTNANCA</p><p>Svojím podpisom potvrdzujem, že som bol oboznámený s vyššie uvedenými predpismi a informáciami v oblasti bezpečnosti a ochrany zdravia pri práci a ochrany pred požiarmi v rozsahu zodpovedajúcom môjmu pracovnému zaradeniu, že uvedeným pokynom a poučeniam som porozumel, mal som možnosť klásť otázky a všetky mi boli zrozumiteľne zodpovedané.</p><p>Zaväzujem sa oboznámené predpisy, pokyny a zásady bezpečnosti a ochrany zdravia pri práci a ochrany pred požiarmi počas výkonu práce dodržiavať, používať pridelené osobné ochranné pracovné prostriedky a bezodkladne oznamovať zistené nedostatky a riziká svojmu nadriadenému. Som si vedomý, že porušenie týchto povinností môže byť posudzované ako porušenie pracovnej disciplíny.</p><p>ÚDAJE O TOM, KTO OBOZNÁMENIE VYKONAL</p><p>Meno a priezvisko: [meno a priezvisko oboznamujúceho]<br>Funkcia / oprávnenie: [funkcia oboznamujúceho]</p><p>Nasledujúce oboznámenie (opakované) sa vykoná najneskôr do: [termín ďalšieho oboznámenia]</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[meno a priezvisko zamestnanca]<br>Oboznámený zamestnanec</td><td>______________________________<br>[meno a priezvisko oboznamujúceho]<br>Oboznámenie vykonal</td></tr><tr><td>______________________________<br>[meno a priezvisko konateľa]<br>konateľ<br>Za zamestnávateľa — KAMIR s.r.o.</td><td></td></tr></tbody></table>",
  "fields": [
   {
    "label": "Meno a priezvisko zamestnanca",
    "ph": "[meno a priezvisko zamestnanca]",
    "zdroj": "zamestnanec.name",
    "typ": "text"
   },
   {
    "label": "Dátum narodenia zamestnanca",
    "ph": "[dátum narodenia zamestnanca]",
    "typ": "date"
   },
   {
    "label": "Pracovná pozícia",
    "ph": "[pracovná pozícia]",
    "typ": "text"
   },
   {
    "label": "Miesto výkonu práce",
    "ph": "[miesto výkonu práce]",
    "typ": "text",
    "hint": "napr. stavby podľa pridelenia / prevádzka Tovarné"
   },
   {
    "label": "Dátum nástupu do zamestnania",
    "ph": "[dátum nástupu]",
    "typ": "date"
   },
   {
    "label": "Druh oboznámenia (vstupné / opakované / mimoriadne)",
    "ph": "[druh oboznámenia — vstupné / opakované / mimoriadne]",
    "typ": "text",
    "default": "vstupné",
    "hint": "vstupné pri nástupe · opakované každé 2 roky · mimoriadne po zmene/úraze"
   },
   {
    "label": "Meno a priezvisko oboznamujúceho",
    "ph": "[meno a priezvisko oboznamujúceho]",
    "typ": "text",
    "hint": "kto školil — bezpečnostný technik alebo poverený vedúci"
   },
   {
    "label": "Funkcia / oprávnenie oboznamujúceho",
    "ph": "[funkcia oboznamujúceho]",
    "typ": "text",
    "hint": "napr. autorizovaný bezpečnostný technik / konateľ"
   },
   {
    "label": "Termín ďalšieho (opakovaného) oboznámenia",
    "ph": "[termín ďalšieho oboznámenia]",
    "typ": "date",
    "hint": "spravidla o 24 mesiacov"
   }
  ]
 },
 {
  "key": "gdpr",
  "label": "Súhlas so spracúvaním osobných údajov (GDPR)",
  "docType": "Súhlas",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<p>SÚHLAS SO SPRACÚVANÍM OSOBNÝCH ÚDAJOV</p><p>udelený podľa čl. 6 ods. 1 písm. a) Nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679 z 27. apríla 2016 o ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe takýchto údajov (ďalej len „GDPR\") a podľa § 13 ods. 1 písm. a) zákona č. 18/2018 Z. z. o ochrane osobných údajov a o zmene a doplnení niektorých zákonov (ďalej len „zákon č. 18/2018 Z. z.\")</p><p>1. PREVÁDZKOVATEĽ</p><p>Obchodné meno: KAMIR s.r.o.<br>Sídlo: Tovarné 29, 094 01 Tovarné<br>IČO: 48029882<br>DIČ: 2120047358<br>IČ DPH: SK2120047358<br>Zapísaná v Obchodnom registri Okresného súdu Prešov, oddiel: Sro, vložka č. 31144/P<br>Zastúpená konateľom: [meno a priezvisko konateľa]<br>(ďalej len „prevádzkovateľ\")</p><p>2. DOTKNUTÁ OSOBA</p><p>Meno a priezvisko: [meno a priezvisko zamestnanca]<br>Dátum narodenia: [dátum narodenia]<br>Adresa pobytu: [adresa pobytu]<br>Štátna príslušnosť: [štátna príslušnosť]<br>Číslo dokladu totožnosti: [číslo dokladu totožnosti]<br>(ďalej len „dotknutá osoba\")</p><p>3. ÚČEL A ROZSAH SPRACÚVANIA OSOBNÝCH ÚDAJOV</p><p>Dotknutá osoba týmto udeľuje prevádzkovateľovi súhlas so spracúvaním svojich osobných údajov na tento účel:</p><p>[účel spracúvania]</p><p>Súhlas sa vzťahuje na spracúvanie osobných údajov v rozsahu:</p><p>[rozsah spracúvaných osobných údajov]</p><p>Tento súhlas sa udeľuje výlučne na účely uvedené v tomto bode, pri ktorých je súhlas dotknutej osoby právnym základom spracúvania. Osobné údaje, ktoré prevádzkovateľ spracúva na plnenie pracovnej zmluvy, na splnenie zákonných povinností prevádzkovateľa alebo na účely jeho oprávnených záujmov, sa spracúvajú na inom právnom základe a tento súhlas sa na ne nevyžaduje ani nevzťahuje.</p><p>4. DOBA SPRACÚVANIA</p><p>Osobné údaje budú spracúvané po dobu: [doba spracúvania], najdlhšie však do odvolania tohto súhlasu dotknutou osobou. Po uplynutí tejto doby, po odvolaní súhlasu alebo po zániku účelu spracúvania budú osobné údaje bez zbytočného odkladu vymazané alebo zlikvidované, ak osobitný právny predpis neustanovuje inak.</p><p>5. PRÁVA DOTKNUTEJ OSOBY</p><p>Dotknutá osoba má v súlade s GDPR a zákonom č. 18/2018 Z. z. najmä tieto práva:<br>- právo na prístup k svojim osobným údajom a na informácie o ich spracúvaní,<br>- právo na opravu nesprávnych a doplnenie neúplných osobných údajov,<br>- právo na výmaz osobných údajov (právo „na zabudnutie\"),<br>- právo na obmedzenie spracúvania osobných údajov,<br>- právo namietať proti spracúvaniu osobných údajov,<br>- právo na prenosnosť osobných údajov,<br>- právo podať návrh na začatie konania na Úrad na ochranu osobných údajov Slovenskej republiky, Hraničná 12, 820 07 Bratislava.</p><p>Svoje práva môže dotknutá osoba uplatniť u prevádzkovateľa písomne na adrese jeho sídla alebo elektronicky na kontaktnej adrese prevádzkovateľa.</p><p>6. DOBROVOĽNOSŤ SÚHLASU A MOŽNOSŤ JEHO ODVOLANIA</p><p>Udelenie tohto súhlasu je dobrovoľné. Poskytnutie súhlasu ani jeho neposkytnutie nemá a nesmie mať vplyv na vznik, trvanie ani podmienky pracovnoprávneho vzťahu dotknutej osoby a nie je podmienkou uzatvorenia pracovnej zmluvy.</p><p>Dotknutá osoba má právo tento súhlas kedykoľvek odvolať, a to rovnakým spôsobom, akým bol udelený, alebo písomným oznámením doručeným prevádzkovateľovi. Odvolanie súhlasu nemá vplyv na zákonnosť spracúvania osobných údajov vykonaného na základe súhlasu pred jeho odvolaním.</p><p>7. VYHLÁSENIE DOTKNUTEJ OSOBY</p><p>Dotknutá osoba vyhlasuje, že bola pred udelením súhlasu zrozumiteľne informovaná o totožnosti prevádzkovateľa, o účele a rozsahu spracúvania osobných údajov, o dobe spracúvania, o svojich právach, ako aj o práve súhlas kedykoľvek odvolať. Dotknutá osoba udeľuje tento súhlas slobodne, vážne, určito a zrozumiteľne.</p><p>V [miesto], dňa [dátum]</p><table><tbody><tr><td>______________________________<br>[meno a priezvisko zamestnanca]<br>Dotknutá osoba (zamestnanec)</td><td>______________________________<br>[meno a priezvisko konateľa]<br>konateľ<br>Za prevádzkovateľa — KAMIR s.r.o.</td></tr></tbody></table>",
  "fields": [
   {
    "label": "Meno a priezvisko zamestnanca",
    "ph": "[meno a priezvisko zamestnanca]",
    "zdroj": "zamestnanec.name",
    "typ": "text"
   },
   {
    "label": "Dátum narodenia",
    "ph": "[dátum narodenia]",
    "zdroj": "zamestnanec.birth_date",
    "typ": "date"
   },
   {
    "label": "Adresa pobytu (trvalý/prechodný pobyt na území SR)",
    "ph": "[adresa pobytu]",
    "typ": "text",
    "hint": "trvalý alebo prechodný pobyt na území SR"
   },
   {
    "label": "Štátna príslušnosť",
    "ph": "[štátna príslušnosť]",
    "typ": "text",
    "hint": "napr. slovenská / ukrajinská"
   },
   {
    "label": "Číslo dokladu totožnosti (OP / pas / doklad o pobyte)",
    "ph": "[číslo dokladu totožnosti]",
    "typ": "text",
    "hint": "OP / pas / doklad o pobyte"
   },
   {
    "label": "Účel spracúvania osobných údajov",
    "ph": "[účel spracúvania]",
    "typ": "textarea",
    "default": "Spracúvanie na plnenie práv a povinností z pracovnoprávneho vzťahu — mzdová a personálna agenda, evidencia dochádzky a dovoleniek, BOZP, plnenie zákonných povinností voči Sociálnej poisťovni, zdravotným poisťovniam, daňovému úradu a ďalším orgánom."
   },
   {
    "label": "Rozsah spracúvaných osobných údajov",
    "ph": "[rozsah spracúvaných osobných údajov]",
    "typ": "textarea",
    "default": "Meno, priezvisko, titul, dátum a miesto narodenia, rodné číslo, adresa pobytu, štátna príslušnosť, číslo dokladu totožnosti, kontaktné údaje, údaje o vzdelaní a praxi, bankové spojenie a údaje potrebné na výpočet mzdy a odvodov."
   },
   {
    "label": "Doba spracúvania",
    "ph": "[doba spracúvania]",
    "typ": "text",
    "default": "Počas trvania pracovného pomeru a následne po dobu stanovenú osobitnými predpismi (napr. mzdové doklady 10 rokov, evidenčné listy dôchodkového poistenia podľa zákona)."
   }
  ]
 },
 {
  "key": "potvrdenie_cinnosti_vodica",
  "label": "Dovolenkový list vodiča (potvrdenie činností 561/2006 · AETR)",
  "docType": "Potvrdenie",
  "mode": "vec",
  "subject": "",
  "pozdrav": "",
  "body": "<div class=\"jednastrana\"><div class=\"nadpis3\"><div class=\"ctr\"><b>POTVRDENIE ČINNOSTÍ</b></div><div class=\"ctr tiny\">(NARIADENIE (ES) 561/2006 ALEBO AETR<sup>1</sup>) &middot; <i>Vyplniť strojopisom a podpísať pred cestou.</i></div><div class=\"ctr\"><b>FALOŠNÉ POTVRDENIA SA POVAŽUJÚ ZA PORUŠENIE PRÁVNYCH PREDPISOV</b></div></div><div class=\"sekcia\"><div><b>Túto časť vyplní podnik</b></div><table class=\"frm firma\"><tbody><tr><td class=\"num\">1.</td><td>Názov podniku</td><td class=\"val\">[názov podniku]</td></tr><tr><td class=\"num\">2.</td><td>Adresa (ulica, PSČ, mesto, štát)</td><td class=\"val\">[adresa podniku], Slovenská republika</td></tr><tr><td class=\"num\">3.</td><td>Telefónne číslo (vrátane medzinárodnej predvoľby)</td><td class=\"val\">[telefón podniku]</td></tr><tr><td class=\"num\">4.</td><td>Číslo faxu (vrátane medzinárodnej predvoľby)</td><td class=\"val\">&mdash;</td></tr><tr><td class=\"num\">5.</td><td>E-mailová adresa</td><td class=\"val\">[e-mail podniku]</td></tr></tbody></table></div><div class=\"sekcia\"><div>Podpísaný:</div><table class=\"frm\"><tbody><tr><td class=\"num\">6.</td><td>Priezvisko a meno</td><td class=\"val\">[meno a priezvisko konateľa]</td></tr><tr><td class=\"num\">7.</td><td>Pozícia v podniku</td><td class=\"val\">konateľ</td></tr></tbody></table></div><div class=\"sekcia\"><div>vyhlasujem, že vodič</div><table class=\"frm\"><tbody><tr><td class=\"num\">8.</td><td>Priezvisko a meno</td><td class=\"val\">[priezvisko a meno vodiča]</td></tr><tr><td class=\"num\">9.</td><td>Dátum narodenia (deň/mesiac/rok)</td><td class=\"val\">[dátum narodenia vodiča]</td></tr><tr><td class=\"num\">10.</td><td>Číslo vodičského preukazu alebo občianskeho preukazu alebo pasu</td><td class=\"val\">[číslo dokladu vodiča]</td></tr><tr><td class=\"num\">11.</td><td>ktorý začal v podniku pracovať dňa (deň/mesiac/rok)</td><td class=\"val\">[dátum nástupu do podniku]</td></tr></tbody></table></div><div class=\"sekcia\"><div>v období:</div><table class=\"frm\"><tbody><tr><td class=\"num\">12.</td><td>od (čas/deň/mesiac/rok)</td><td class=\"val\">[obdobie od]</td></tr><tr><td class=\"num\">13.</td><td>do (čas/deň/mesiac/rok)</td><td class=\"val\">[obdobie do]</td></tr><tr><td class=\"num\">14.</td><td>Dôvod<sup>2</sup></td><td class=\"val\">[dôvod neprítomnosti]</td></tr><tr><td class=\"num\">15.</td><td>Miesto</td><td class=\"val\">[miesto]</td></tr><tr><td class=\"num\">16.</td><td>Dátum</td><td class=\"val\">[dátum]</td></tr></tbody></table></div><div class=\"sekcia\"><table class=\"frm\"><tbody><tr><td class=\"num\">18.</td><td class=\"full\">Ja, vodič, potvrdzujem, že som neriadil vozidlo patriace do pôsobnosti nariadenia (ES) č. 561/2006 alebo AETR počas vyššie uvedeného obdobia.</td></tr><tr><td class=\"num\">19.</td><td>Miesto</td><td class=\"val\">[miesto]</td></tr><tr><td class=\"num\">20.</td><td>Dátum</td><td class=\"val\">[dátum]</td></tr></tbody></table></div><table><tbody><tr><td>[pečiatka a podpis]______________________________<br><b>[meno a priezvisko konateľa]</b><br>[názov podniku] &middot; konateľ</td><td><div class=\"sigsp\"></div>______________________________<br>Podpis vodiča<br><b>[priezvisko a meno vodiča]</b></td></tr></tbody></table><div><small><sup>1</sup> Európska dohoda o práci osádok vozidiel v medzinárodnej cestnej doprave.<br><sup>2</sup> Uvádza sa iba jeden dôvod.<br>Uchovávať s pôvodnými tachografovými záznamami, kdekoľvek sa ich uchovanie požaduje. Formulár podľa rozhodnutia Komisie 2007/230/ES v znení rozhodnutia 2009/959/EÚ. Originál dostupný na transport.ec.europa.eu.</small></div></div>",
  "fields": [
   {
    "label": "Vodič — priezvisko a meno",
    "ph": "[priezvisko a meno vodiča]",
    "typ": "text",
    "zdroj": "zamestnanec.name",
    "hint": "presne ako v doklade"
   },
   {
    "label": "Dátum narodenia vodiča",
    "ph": "[dátum narodenia vodiča]",
    "typ": "date",
    "zdroj": "zamestnanec.birth_date"
   },
   {
    "label": "Číslo vodičského preukazu / OP / pasu",
    "ph": "[číslo dokladu vodiča]",
    "typ": "text",
    "zdroj": "zamestnanec.doklad_cislo",
    "hint": "stačí jeden z dokladov"
   },
   {
    "label": "Dátum nástupu vodiča do podniku",
    "ph": "[dátum nástupu do podniku]",
    "typ": "date",
    "zdroj": "zamestnanec.datum_nastupu"
   },
   {
    "label": "Obdobie OD (čas a dátum)",
    "ph": "[obdobie od]",
    "typ": "cas_datum",
    "hint": "hodiny a minúty + dátum — musí sedieť s dierou v tachografe"
   },
   {
    "label": "Obdobie DO (čas a dátum)",
    "ph": "[obdobie do]",
    "typ": "cas_datum",
    "hint": "hodiny a minúty + dátum — musí sedieť s dierou v tachografe (koniec dňa = 24:00)"
   },
   {
    "label": "Dôvod neprítomnosti",
    "ph": "[dôvod neprítomnosti]",
    "typ": "select",
    "opts": [
     "bol práceneschopný",
     "čerpal riadnu dovolenku",
     "mal voľno alebo odpočíval",
     "riadil vozidlo vyňaté z pôsobnosti nariadenia (ES) č. 561/2006 alebo AETR",
     "vykonával inú činnosť ako riadenie vozidla",
     "bol k dispozícii"
    ],
    "hint": "do dokumentu ide len vybraná možnosť"
   }
  ]
 }
]
